import { InjectionToken } from '@angular/core';
import { ApplianceDetailsFormDataProvider } from '@common/util-models';

export const APPLIANCE_DETAILS_FORM_DATA_PROVIDER = new InjectionToken<ApplianceDetailsFormDataProvider>(
  'Provider for appliance details form data'
);
